import Vue from 'vue'
import { mapState } from 'vuex'


//全局混入mixin
Vue.mixin({
    data(){
        return {
            siteroot: process.env.VUE_APP_SITEROOT,  //根域名
            ossUrl: 'https://wjdt.oss-cn-beijing.aliyuncs.com'
        }
    },
    computed: {
      ...mapState('userinfo', ['userinfo']), //用户信息
      // ...mapState('global', ['system']), //全局参数
      ...mapState('status', ['isLogin']), //全局状态，网络状态，登录状态
      getAuthHeaders() { //相当于是挂载到Vue实例上可以在每个页面调用
        return {
          Authorization: `Bearer ${localStorage.token || ''}`
        }
      },
      imageUploads(){
        return this.siteroot + '/index/login/xcxsctp'
      },
      fileUploads(){
        return this.siteroot + '/index/ptgdguanli/fcs'
      }
    },
    methods: {
      //获取用户信息
      async getUserInfo(t){
          let res = await t.$request({url: t.$api.user.getuserinfo })
          if (1 == res.code) {
              if (res.data.info) t.$store.commit('userinfo/USERINFO', res.data.info)
          }
      }
    }
  })